import cx from 'clsx';
import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { usePdfPreviewContext } from '../pdf-preview-context.tsx';
import { Placeholder } from './internals/placeholder';
import styles from './details-placeholder.module.css';

export function DocumentDetailsPlaceholder({ children }: PropsWithChildren): ReactNode {
  const { variant } = usePdfPreviewContext();
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.DocumentDetails);

  if (showPlaceholder) {
    return (
      <div className={styles.details}>
        <div className={cx(styles.detail, styles[variant])}>
          <div className={styles.label}>
            <Placeholder width="51px" />
          </div>
          <Placeholder width="123px" />
        </div>
        <div className={cx(styles.detail, styles[variant])}>
          <div className={styles.label}>
            <Placeholder width="43px" />
          </div>
          <Placeholder width="75px" />
        </div>
        <div className={cx(styles.detail, styles[variant])}>
          <div className={styles.label}>
            <Placeholder width="84px" />
          </div>
          <Placeholder width="57px" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
